import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, costProfile }) =>
    present(
      repository
        .saveCostProfile(planzone, costProfile)
        .then((savedCostProfile) => ({
          planzone,
          costProfile: savedCostProfile,
        }))
        .catch(() => Promise.reject({ planzone, costProfile })),
    );
}

export type { Interactor };

export { createInteractor };
